import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";

/**
 * Dialogue pour mettre une commande en attente ou la réactiver.
 */
export const OnHoldDialog = ({
  open,
  onOpenChange,
  orderToHold,
  holdData,
  setHoldData,
  onConfirm,
}) => {
  const isReactivating = !!orderToHold?.is_on_hold;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-heading">
            {isReactivating ? "Réactiver la commande" : "Mettre en pause"}
          </DialogTitle>
          <DialogDescription>
            {isReactivating
              ? "Réactivez cette commande pour qu'elle soit à nouveau prise en compte."
              : "Mettez cette commande en pause et choisissez si elle doit être exclue du planning et/ou du stock."}
          </DialogDescription>
        </DialogHeader>

        {!isReactivating && (
          <div className="space-y-4">
            <div className="space-y-2">
              <Label>Raison de la mise en pause</Label>
              <Select
                value={holdData.on_hold_reason}
                onValueChange={(v) => setHoldData({ ...holdData, on_hold_reason: v })}
              >
                <SelectTrigger data-testid="hold-reason-select">
                  <SelectValue placeholder="Sélectionner une raison..." />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="En attente d'autres travaux">En attente d'autres travaux</SelectItem>
                  <SelectItem value="En attente de paiement">En attente de paiement</SelectItem>
                  <SelectItem value="En attente de primes">En attente de primes</SelectItem>
                  <SelectItem value="En attente de matériaux">En attente de matériaux</SelectItem>
                  <SelectItem value="Client indisponible">Client indisponible</SelectItem>
                  <SelectItem value="Autre">Autre</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-3 border-t pt-4">
              <Label className="text-sm font-medium">Options d'exclusion</Label>
              <div className="flex items-center space-x-2">
                <Checkbox
                  id="exclude_planning"
                  checked={holdData.exclude_from_planning}
                  onCheckedChange={(c) => setHoldData({ ...holdData, exclude_from_planning: c })}
                  data-testid="exclude-planning-checkbox"
                />
                <Label htmlFor="exclude_planning" className="text-sm">
                  Exclure du calendrier et du planning
                </Label>
              </div>
              <div className="flex items-center space-x-2">
                <Checkbox
                  id="exclude_stock"
                  checked={holdData.exclude_from_stock}
                  onCheckedChange={(c) => setHoldData({ ...holdData, exclude_from_stock: c })}
                  data-testid="exclude-stock-checkbox"
                />
                <Label htmlFor="exclude_stock" className="text-sm">
                  Exclure du calcul du stock en jours
                </Label>
              </div>
            </div>
          </div>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Annuler
          </Button>
          <Button
            onClick={onConfirm}
            className={isReactivating ? "bg-green-600 hover:bg-green-700" : "bg-yellow-600 hover:bg-yellow-700"}
            data-testid="confirm-hold-btn"
          >
            {isReactivating ? "Réactiver" : "Mettre en pause"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default OnHoldDialog;
